import { useTranslation } from 'react-i18next'

import { ScrollableTabs, Text } from '@reveni-io/reveni-ui'

import useTabsSearchParam from '@/configuration/pages/ConfigurationPage/hooks/useTabsSearchParam/useTabsSearchParam'
import AvailabilityCriteriaTab from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/components/AvailabilityCriteriaTab/AvailabilityCriteriaTab'
import configurationServices from '@/configuration/services/services'
import routes from '@/Router/routes.constants'

import ShippingMethodsTab from './ShippingMethodsTab/ShippingMethodsTab'
import { shippingMethodsTabList, shippingMethodsTabs } from './constants'
import * as Styles from './styles'

const ShippingMethodsConfiguration = () => {
  const { t } = useTranslation()

  const tabs = shippingMethodsTabList.map(tab => ({ ...tab, label: t(tab.label) }))

  const { activeTab, onChangeTab } = useTabsSearchParam({
    tabs,
    defaultTab: shippingMethodsTabs.shippingMethods,
  })

  return (
    <Styles.Container>
      <Text type="bodyMRegular">
        {t(
          'Define los métodos de envío que los clientes podrán escoger al hacer pedidos en tu tienda, y sus criterios de disponibilidad'
        )}
        :
      </Text>
      <ScrollableTabs tabs={tabs} value={activeTab} onChange={onChangeTab} />
      {activeTab === shippingMethodsTabs.shippingMethods && <ShippingMethodsTab />}
      {activeTab === shippingMethodsTabs.availabilityCriteria && (
        <AvailabilityCriteriaTab
          getAvailabilityCriteria={configurationServices.getShippingAvailabilityCriteria}
          reorderAvailabilityCriteria={configurationServices.reorderShippingAvailabilityCriteria}
          deleteAvailabilityCriterion={configurationServices.deleteShippingAvailabilityCriterion}
          detailRoute={routes.configurationPage.logistics.shippingAvailabilityCriterionDetail}
        />
      )}
    </Styles.Container>
  )
}

export default ShippingMethodsConfiguration
